<template>
    <svg
        class="icon-facebook fill-current"
        viewBox="0 0 16.266 30.359"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M15.2,17.077l.843-5.494H10.766V8.017a2.748,2.748,0,0,1,3.1-2.968h2.4V.371A29.318,29.318,0,0,0,12.01,0C7.668,0,4.83,2.632,4.83,7.4v4.187H0v5.494H4.826V30.359h5.94V17.077Z" /></svg>
</template>
